import React from 'react'

const Loading = () => <div className="page-loading"></div>

export default Loading
